
import AppSearchBrowse from "@/components/browse/SearchBrowse.vue";
import { Sale, SaleRow } from "@/models/base";
import { BrowseService } from "@/services/browse-service";
import { IBrowseBaseDataSource } from "@/utils/browse/browse-data-source";
import { HumanFilter } from "@/utils/human-filter";
import Vue from "vue";
import { BookYearService } from "@/services/book-year-service";
import AppSelectBookYear from "@/components/bookyear/SelectBookYear.vue";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { IQueryParams } from "@/utils/query-params";
import { IGetResponse } from "@/utils/get-response";
import { SaleRowService } from "@/services/sale-row-service";

export default Vue.extend({
	data(){
		return{
			selectedBookYear: `${BookYearService.selectedBookYear}`,
		};
	},
	props: {
		contactId: {
			type: Number,
			default: 0
		},
		filterOpen: {
			type: Boolean,
			default: false
		},
		bookYearSelect: {
			type: Boolean,
			default: false
		},
		clearViewSettingsFilters: Boolean,
		allowViewButton: Boolean,
		view: Object as ()=>View
	},
	computed: {
		extraFilters():HumanFilter[]{
			return [];
		},
		dataSource():IBrowseBaseDataSource<SaleRow> {
			let t = this;
			return {
				getSettings: () => BrowseService.getBrowse(7),
				getElements: (params)=>SaleRowService.getSalesRows(params, this.extraFilters),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return SaleRowService.getTotals(view);
				},
				browseName: "SaleRows",
				modelName: "SaleRow",
				info(s:SaleRow){
					t.$router.push(`/sales/info/${s.SaleID}`);
				},
				staticViewGetElements(view:View, params:IQueryParams):Promise<IGetResponse<any>>{
					return SaleRowService.getSaleRowsStaticView(view, params, t.selectedBookYear, t.extraFilters);
				}
			};
		}
	},
	methods: {
		onClick(sale:Sale) {
			this.$emit("click", sale);
		},
		onBookYearChange(bookyear:string) {
			this.selectedBookYear = bookyear;
			let browse = this.$refs.browse as any;
			if (!browse) return;
			browse.refresh();
		}
	},
	components: {
		AppSearchBrowse,
		AppSelectBookYear
	}
});
